import { AlertColor } from "@mui/material";
import React from "react";
import { JwtAuth } from "../Models/JwtAuth";
import { User } from "../Models/User";

export interface AppProviderState {
    
    showMessage: ( msg: string, open: boolean, severity: AlertColor ) => void,
    setToken: (token: string) => void,
    setUser: (user: User) => void,
    getToken: () => string,
    jwtAuth: JwtAuth | null,
    user: User | null;

}

export const AppProvider = React.createContext<AppProviderState>({
    showMessage: (msg,open,severity) => {},
    setToken: (token) => {},
    setUser: (user) => {},
    getToken: () => '',
    jwtAuth: null,
    user: null
});